module.exports = __webpack_public_path__ + "static/media/RS.59a86504.png";